import axios from 'axios';


const iconBase = MAPsettings.iconsFolder;//iconsFolder are set in "AttractionsListMap.cshtml"

//We may need different markers in the future
const icons = {
    marker: {
        icon: iconBase + "marker.png"
    },
    markerSelected: {
        icon: iconBase + "marker-selected.png"
    },
    info: {
        icon: iconBase + "info-i_maps.png"
    }
};
const siteConfig = {};
Object.assign(siteConfig, window.merlinConfig);

//REMEMBER TO ADD THESE IF WE GO BACK TO GEOCODER
//var geoCoder = new google.maps.Geocoder();
//const geoCoderComponentRestrictions = {
//    country: "GB"
//};

let markersArray = [];
const noResultsContainer = document.querySelector("#AttractionsResult");
const form = document.querySelector("#google-maps-form");
const formInput = document.querySelector("#google-maps-input");
formInput.disabled = false;




const defaultArrow =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" width="16" height="12" aria-hidden="true" focusable="false">
  <path d="M11.5355339 5L8.2426407 1.7071068c-.3905243-.3905243-.3905243-1.0236893 0-1.4142136.3905243-.39052427 1.0236893-.39052427 1.4142135 0l5.6568543 5.6568543-5.6568543 5.6568542c-.3905242.3905243-1.0236892.3905243-1.4142135 0-.3905243-.3905243-.3905243-1.0236893 0-1.4142135L11.4350288 7H1c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h10.5355339z"></path>
</svg>`;

const pinMarker =
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false" style="width:24px;height:24px;transform:translateX(-5px);">
  <path d="M16.3333333 16.85c-2.8856878 0-5.225-2.3393122-5.225-5.225 0-2.88568782 2.3393122-5.225 5.225-5.225 2.8856879 0 5.225 2.33931218 5.225 5.225 0 2.8856878-2.3393121 5.225-5.225 5.225zm0-1.7c1.9468038 0 3.525-1.5781963 3.525-3.525 0-1.94680374-1.5781962-3.525-3.525-3.525-1.9468037 0-3.525 1.57819626-3.525 3.525 0 1.9468037 1.5781963 3.525 3.525 3.525zm0-13.125c5.3019336 0 9.6 4.2980664 9.6 9.6 0 3.4516763-4.1917749 11.5931703-8.1625 17.5790218-.3195985.481813-.8593244.7714704-1.4375.7714704-.5781755 0-1.1179014-.2896574-1.4374912-.7714572C10.9251083 23.2181703 6.73333333 15.0766763 6.73333333 11.625c0-5.3019336 4.29806637-9.6 9.59999997-9.6zm0 1.7c-4.3630495 0-7.89999997 3.53695048-7.89999997 7.9 0 2.967324 4.12683247 10.9826834 7.87916667 16.6393115.0046319.0069828.012454.0111807.0208333.0111807.0083794 0 .0162015-.0041979.0208421-.0111939C20.1065008 22.6076834 24.2333333 14.592324 24.2333333 11.625c0-4.36304952-3.5369504-7.9-7.9-7.9z" />
</svg>`;

var markerClusterer;


var selectFirstOnEnter = function (input) {

    // store the original event binding function
    var eventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
    function addEventListenerWrapper(type, listener) {
        if (type == "keydown") {
            var origListener = listener;
            listener = function (event) {
                var suggestionSelected = $(".pac-item-selected").length > 0;
                if (event.which == 13 && !suggestionSelected) {
                    var simulatedDownarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                    origListener.apply(input, [simulatedDownarrow]);
                }
                origListener.apply(input, [event]);
            };
        }
        // add the modified listener
        eventListener.apply(input, [type, listener]);
    }

    if (input.addEventListener) {
        input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
        input.attachEvent = addEventListenerWrapper;
    }
};

var map = new google.maps.Map(document.getElementById("AttractionsMap"), MAPsettings.mapDefaultOptions);


const autocomplete = new google.maps.places.Autocomplete(formInput);
autocomplete.setComponentRestrictions(MAPsettings.restrictions);
//autocomplete.setTypes(['(regions)']);
autocomplete.setFields(["geometry", "name"]);// Specify only the data fields that are needed.
autocomplete.addListener("place_changed", () => {

    const place = autocomplete.getPlace();
    infowindow.close();

    if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        console.log("No details available for input: '" + place.name + "'");
        return;
    }

    // If the place has a geometry, then present it on a map.
    if (place.geometry.location) {
        map.setCenter(place.geometry.location);
        map.setZoom(12);
        loadData(place.geometry.location.lat().toString(), place.geometry.location.lng().toString(), true);
    }

});


//restrictions are set in "AttractionsListMap.cshtml"
console.log("Countries restricted to: ", autocomplete.componentRestrictions.country);



selectFirstOnEnter(formInput);

//https://developers.google.com/maps/documentation/javascript/custom-markers


var infowindow = new google.maps.InfoWindow();

function AttractionsForGoogleMapsViewCallback(results, zoom = false) {

    if (markerClusterer) {
        markerClusterer.clearMarkers();
    }

    markersArray = results.data.attractions.map((location, i) => {

        let distance = "";

        if (location.distanceString && location.distanceString !== "") {
            distance = `<p>${location.distanceString}</p>`;
        }

        const contentString =
            `<div id="content">
                        <div id="siteNotice"></div>
                        <h3>${location.title}</h3>
                        <div id="bodyContent">
                            <p>${location.text}</p>
                            ${distance}
                            <p><a href="${location.link.url}" target="${location.link.target}">${location.link.label}</a></p>
                        </div>
                    </div>`;

        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(location.latitude, location.longitude),
            map: map,
            icon: icons.marker.icon,
            title: location.title,
            html: contentString

        });

        google.maps.event.addListener(marker, 'click', function () {

            markersArray.forEach(function (marker) {
                marker.setIcon(icons.marker.icon);
            });

            if (infowindow) {
                infowindow.close();
            }

            infowindow.setContent(this.html);
            infowindow.open(map, this);
            this.setIcon(icons.markerSelected.icon);

        });

        return marker;
    });


    google.maps.event.addDomListener(map, "click", () => {
        if (infowindow) {
            infowindow.close();
        }

        markersArray.forEach(function (marker) {
            marker.setIcon(icons.marker.icon);
        });
    });

    google.maps.event.addListener(infowindow, 'closeclick', function () {
        markersArray.forEach(function (marker) {
            marker.setIcon(icons.marker.icon);
        });
    });

    markerClusterer = new MarkerClusterer(map, markersArray, {
        imagePath: iconBase + "m",
    });

    //Set center on the closest attraction
    //Returned attractions are sorted by distance so just pick the first one
    if (markersArray.length > 0 && zoom) {
        var centerOnFirstAttraction = new google.maps.LatLng(markersArray[0].position.lat(), markersArray[0].position.lng());
        map.panTo(centerOnFirstAttraction);
        map.setZoom(14);
    }

};


function AttractionsForListViewCallback(results) {
    const container = document.getElementById("AttractionsListContainer");
    container.innerHTML = "";
    //noResultsContainer.hidden = true;

    //if (results.data.Attractions.length <= 0) {
     //   noResultsContainer.hidden = false;
       // return;
   // }

    if (results.data.searchResultText !== undefined && results.data.searchResultText !== "") {
        noResultsContainer.hidden = false;
        noResultsContainer.innerHTML = results.data.searchResultText;
    }
   

    let list = results.data.attractions.map((location, i) => {

        let distance = "";
        let image = "";
        let teaserText = "";

        if (location.distanceString && location.distanceString !== "") {
            distance = `<p class="flex-container align-middle">${pinMarker} ${location.distanceString}</p>`;
        }

        if (location.image && location.image !== "") {
            image = `<div class="attraction-link-image"><img src="${location.image}" width="700" height="500" alt=""></div>`;
        }
        if (location.text && location.text !== "") {
            teaserText = `<p>${location.text}</p>`;
        }

        let listItem =
            `<li>
                <a href="${location.link.url}" target="${location.link.target}" class="list-item-content-wrapper">
                    ${image}
                    <div class="attraction-link-content stack">
                        <h2 class="header--small">${location.title}</h2>
                        ${teaserText}
                        ${distance}
                    </div>
                    <div class="attraction-link-label">
                        ${defaultArrow}
                        ${location.link.label}
                    </div>
                </a>
            </li>`;

        return listItem;
    });

    let listHtml = `<ul class="attractions-list">${list.join("")}</ul>`;

    container.innerHTML = listHtml;

};




function loadData(lat = "", lng = "", zoom = false) {
    let urlParams = "";
    if (lat !== "" && lng !== "") {
        urlParams = `?latitude=${lat}&longitude=${lng}&searchterm=${formInput.value}`;
    }

    axios.get(`${siteConfig.urlPrefix}/umbraco/api/mapfiltering/GetAttractions${urlParams}`)
        .then(response => {
            AttractionsForGoogleMapsViewCallback(response, zoom);
            AttractionsForListViewCallback(response);

        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            //loading = false;
        });
}



window.addEventListener("load", function () {
    loadData();
});


//findPlaceFromQuery Example
//function getLocationFromAddress(address) {

//    var request = {
//        query: address,
//        fields: ['geometry']
//    };

//    var service = new google.maps.places.PlacesService(map);

//    service.findPlaceFromQuery(request, function (results, status) {
//        if (status === google.maps.places.PlacesServiceStatus.OK) {
//            map.setCenter(results[0].geometry.location);
//            map.setZoom(8);
//            loadData(results[0].geometry.location.lat().toString(), results[0].geometry.location.lng().toString());
//        } else {
//            console.log("findPlaceFromQuery was not successful for the following reason: " + status);
//        }
//    });

//}


//function getLocationFromAddress(address) {

//    const request = {
//        address: address
//    };

//    geoCoder.geocode(request, function (results, status) {
//        if (status === "OK") {
//            map.setCenter(results[0].geometry.location);
//            map.setZoom(15);
//            loadData(results[0].geometry.location.lat().toString(), results[0].geometry.location.lng().toString());
//        } else {
//            console.log("Geocode was not successful for the following reason: " + status);
//        }
//    });
//}